import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';

const fromDtoToTimeOffReport = (item) =>
  !item
    ? item
    : fromEntriesToObject(
        Object.entries(item).map(([stylistId, rows]) => [
          stylistId,
          fromEntriesToObject(
            Object.entries(rows).map(([categoryId, cell]) => [
              categoryId,
              {
                stylistId,
                categoryId,
                allowanceDays: cell.allowance_days,
                allowanceHours: cell.allowance_hours,
                categoryName: cell.category_name,
                excessDays: cell.excess_days,
                excessHours: cell.excess_hours,
                remainingDays: cell.remaining_days,
                remainingHours: cell.remaining_hours,
                upcomingDays: cell.upcoming_days,
                upcomingHours: cell.upcoming_hours,
                usedDays: cell.used_days,
                usedHours: cell.used_hours,
              },
            ]),
          ),
        ]),
      );

export default fromDtoToTimeOffReport;
